
export const getDefaultOperatorCode = () => {
    return window.location.pathname.split("/")[1].toUpperCase(); 
  };